(() => {
 let busy = false;
 let pendingOutfit=null;
 const messages = () => document.getElementById('af-messages');
 const message = key => messages()?.dataset[key] || key;
 function error(root, text) {
  const el = root.querySelector('[data-af-error]');
  if(el){el.hidden = !text; el.textContent = text;}
 }

 /* Gratisguertel: pro vollstaendigem Paar (Jacke + Jeans desselben Looks) genau ein Geschenk-Guertel (0 EUR). Liegt derselbe Guertel schon bezahlt im Warenkorb, wird er durch den Geschenk-Guertel ersetzt (nie beide). */
 const GIFT = window.AURA_GIFT || [];
 let syncing = false, queued = false, timer = null;
 async function giftSync() {
  if(!GIFT.length) return false;
  if(syncing){queued = true; return false;}
  syncing = true;
  let changed = false;
  try {
   const route = window.Shopify.routes.root;
   const headers = {'Content-Type':'application/json',Accept:'application/json','X-Aura-Sync':'1'};
   for(let pass = 0; pass < 8; pass++) {
    const response = await fetch(route+'cart.js',{headers:{Accept:'application/json','X-Aura-Sync':'1'}});
    if(!response.ok) break;
    const cart = await response.json();
    const sum = test => cart.items.filter(test).reduce((total,line)=>total+line.quantity,0);
    let action = null;
    for(const look of GIFT) {
     const want = Math.min(sum(line=>line.handle===look.jacket), sum(line=>line.handle===look.jeans));
     const have = sum(line=>Number(line.variant_id)===Number(look.gift));
     if(want > have) {
      const paid = cart.items.find(line=>line.handle===look.look+'-denim-gurtel' && Number(line.variant_id)!==Number(look.gift));
      if(paid){action = {paid,qty:Math.max(0,paid.quantity-(want-have))}; break;}
     }
     if(want !== have){action = {look,want,have}; break;}
    }
    if(!action) break;
    let result;
    if(action.paid) {
     result = await fetch(route+'cart/change.js',{method:'POST',headers,body:JSON.stringify({id:String(action.paid.key),quantity:action.qty})});
    } else {
     result = action.have === 0
      ? await fetch(route+'cart/add.js',{method:'POST',headers,body:JSON.stringify({items:[{id:Number(action.look.gift),quantity:action.want}]})})
      : await fetch(route+'cart/change.js',{method:'POST',headers,body:JSON.stringify({id:String(action.look.gift),quantity:action.want})});
    }
    if(!result.ok) break;
    changed = true;
   }
  } catch(e) {}
  finally {syncing = false;}
  if(changed) {
   if(/\/cart\/?$/.test(location.pathname)) location.reload();
   else document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  if(queued){queued = false; giftSync();}
  return changed;
 }
 window.auraGiftSync = giftSync;
 const nativeFetch = window.fetch.bind(window);
 window.fetch = function(input, init) {
  const promise = nativeFetch(input, init);
  try {
   const url = typeof input === 'string' ? input : ((input && input.url) || '');
   const headers = init && init.headers;
   const own = headers && (headers['X-Aura-Sync'] || (typeof headers.get === 'function' && headers.get('X-Aura-Sync')));
   if(!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
    promise.then(()=>{clearTimeout(timer); timer = setTimeout(giftSync,350);}).catch(()=>{});
   }
  } catch(e) {}
  return promise;
 };
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>giftSync()); else giftSync();

 async function add(root, requests, button) {
  if(busy) return;
  busy = true; button.disabled = true; button.setAttribute('aria-busy','true'); error(root,'');
  try {
   const route = window.Shopify.routes.root;
   const beforeResponse = await fetch(route+'cart.js',{headers:{Accept:'application/json'}});
   if(!beforeResponse.ok) throw new Error(message('failed'));
   const before = await beforeResponse.json();
   const missing = requests.map(request=>{const q=request.target ? Math.max(0,request.target-before.items.filter(line=>Number(line.product_id)===Number(request.productId)).reduce((sum,line)=>sum+line.quantity,0)) : (before.items.some(line=>Number(line.variant_id)===Number(request.id)) ? 0 : 1);return {id:Number(request.id),quantity:q};}).filter(item=>item.quantity>0);
   if(!missing.length){
    await giftSync();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    const drawer = document.getElementById('cart-drawer');
    if(drawer) drawer.addEventListener('cart-drawer:refreshed',()=>drawer.show(),{once:true});
    return;
   }
   const sections = [];
   document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
   const response = await fetch(route+'cart/add.js',{
    method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Aura-Sync':'1'},
    body:JSON.stringify({items:missing,sections:sections.join(','),sections_url:location.pathname})
   });
   const result = await response.json();
   if(!response.ok) throw new Error(result.description || message('failed'));
   await giftSync();
   const cartResponse = await fetch(route+'cart.js',{headers:{Accept:'application/json'}});
   if(!cartResponse.ok) throw new Error(message('refreshFailed'));
   const cart = await cartResponse.json(); cart.sections = result.sections;
   document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart,onSuccessDo:'force_open_drawer'}}));
  } catch(e) { error(root,e.message || message('failed')); }
  finally {busy=false;button.disabled=false;button.removeAttribute('aria-busy');}
 }
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-af-add],[data-af-add-outfit]');
  if(!button)return;
  const root=button.closest('[data-af-outfit]');if(!root)return;
  if(button.hasAttribute('data-af-add')){add(root,[{id:button.dataset.afAdd,productId:button.dataset.afProduct,target:Number(button.dataset.afTarget)||1}],button);return;}
  const selectors=[...root.querySelectorAll('[data-af-size]')];
  const missing=selectors.find(select=>!select.value||select.disabled);
  if(missing){error(root,message('sizes'));missing.focus();return;}
  add(root,selectors.map(select=>({id:select.value})),button);
 });

 function sync(detail){
  const root=detail.querySelector('[data-af-outfit]');
  const info=detail.closest('.product-info');
  const chosen=info?.querySelector('variant-picker input[type=radio]:checked');
  const label=(chosen?.labels?.[0]?.textContent||'').replace(/Model/g,'').trim();
  const select=root?.querySelector('[data-product-id="'+root.dataset.currentProduct+'"] select');
  if(select&&label){const option=[...select.options].find(option=>option.textContent.trim()===label);if(option)select.value=option.value;}
  updatePrice(root);
 }
 function updatePrice(root){
  if(!root)return;
  const price=root.querySelector('[data-af-price]');if(!price)return;
  const selects=[...root.querySelectorAll('[data-af-size]')];
  if(selects.some(select=>!select.value))return;
  const hasSaving=root.dataset.afSaving!==undefined&&root.dataset.afSaving!=='';
  const total=hasSaving
   ? Math.max(0,selects.reduce((sum,select)=>sum+Number(select.selectedOptions[0].dataset.price),0)-Number(root.dataset.afSaving))
   : selects.reduce((sum,select)=>sum+Math.round(Number(select.selectedOptions[0].dataset.price)*(1-Number(root.dataset.afDiscount)/100)),0);
  price.textContent=new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:window.Shopify.currency.active}).format(total/100);
 }
 document.addEventListener('toggle',event=>{const detail=event.target;if(detail.matches('[data-af-mode]')&&detail.open)sync(detail);},true);
 document.addEventListener('variant:change',event=>{const info=event.target.closest('.product-info');if(!info)return;const choices=event.detail?.variant?.options||[];info.querySelectorAll('variant-picker input[type=radio]').forEach(input=>{const label=(input.labels?.[0]?.textContent||'').replace(/Model/g,'').trim();const position=Number(input.dataset.optionPosition||1)-1;input.checked=String(choices[position])===label;});const detail=info.querySelector('[data-af-mode]');const root=detail?.querySelector('[data-af-outfit]');if(root&&pendingOutfit?.product===root.dataset.currentProduct){detail.open=true;root.querySelectorAll('[data-af-size]').forEach((select,index)=>{const value=pendingOutfit.values[index];if([...select.options].some(option=>option.value===value))select.value=value;});pendingOutfit=null;}info.querySelectorAll('[data-af-mode][open]').forEach(sync);});
 document.addEventListener('change',event=>{
  if(event.target.matches('variant-picker input[type=radio]')){const detail=event.target.closest('.product-info')?.querySelector('[data-af-mode][open]');const root=detail?.querySelector('[data-af-outfit]');if(root)pendingOutfit={product:root.dataset.currentProduct,values:[...root.querySelectorAll('[data-af-size]')].map(select=>select.value)};}
  const select=event.target.closest('[data-af-size]');if(!select)return;
  const root=select.closest('[data-af-outfit]');
  const piece=select.closest('[data-af-piece]');
  const info=select.closest('.product-info');
  if(piece.dataset.productId===root.dataset.currentProduct&&info){
   const radio=[...info.querySelectorAll('variant-picker input[type=radio]')].find(input=>(input.labels?.[0]?.textContent||'').replace(/Model/g,'').trim()===select.selectedOptions[0].textContent.trim());
   if(radio&&!radio.checked){pendingOutfit={product:root.dataset.currentProduct,values:[...root.querySelectorAll('[data-af-size]')].map(select=>select.value)};radio.click();}
  }
  updatePrice(root);
 });
 document.addEventListener('change',event=>{
  const country=event.target.closest('[data-af-country]');if(!country)return;const language=country.form.querySelector('[data-af-language]');if(!language||language.dataset.chosen)return;const preferred=['DE','AT'].includes(country.value)?'de':'en';if([...language.options].some(option=>option.value===preferred))language.value=preferred;
 });
 document.addEventListener('change',event=>{if(event.target.matches('[data-af-language]'))event.target.dataset.chosen='true';});
 document.addEventListener('click',event=>{
  const link=event.target.closest('[data-af-jump]');if(!link)return;
  const target=document.querySelector(link.getAttribute('href'));if(!target)return;
  event.preventDefault();if(target.matches('details'))target.open=true;
  target.tabIndex=-1;target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
 });
})();
